export const DEFAULT_SALE_COPIES = 1;
export const MIN_SALE_COPIES = 1;
export const MAX_SALE_COPIES = 10;

export const normalizeSaleCopies = (value: number | null | undefined): number =>
  value ?? DEFAULT_SALE_COPIES;

export const getSaleCopiesValidationError = (value: number): string | undefined => {
  if (!Number.isInteger(value)) {
    return 'La cantidad de copias debe ser un número entero.';
  }
  if (value < MIN_SALE_COPIES) {
    return 'Debe imprimir al menos una copia.';
  }
  if (value > MAX_SALE_COPIES) {
    return 'No puede configurar más de 10 copias.';
  }
  return undefined;
};
